export default {
  title: 'Customers',
  newTitle: 'New Customers',
  installationsListTitle: 'Installation List',
  returnedOfflineCustomer: 'Returned Offline',
  classify: 'Classify',
  search: {
    title: 'Customer Search',
    placeholder: 'Search customers...',
    noResults: 'No customers found. Try a different search term.',
    loading: 'Searching...',
    error: 'Search error',
    searchPrompt: 'Search for a customer to view details',
    customerDetails: 'Customer Details',
    financial: 'Financial',
    technicalInfo: 'Technical Information',
    quickActions: 'Quick Actions',
    fields: {
      balance: 'Balance',
      currentPackage: 'Current Package',
      packagePrice: 'Package Price',
      serviceStatus: 'Service Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
      unknown: 'Unknown',
      ping: 'Ping',
      site: 'Site',
      baseStation: 'Base Station',
      ip: 'IP',
      signal: 'Signal',
      signalStrength: 'Signal strength',
      signalToNoise: 'Signal to noise (SNR)',
      ccq: 'CCQ',
      usage: 'Usage',
      bandwidth: 'Bandwidth',
      connectedDevices: 'Connected Devices',
      base: 'Base',
      totalInvoiced: 'Total Invoiced',
      totalBalance: 'Total Balance',
      paidInvoices: 'Paid Invoices',
      unpaidInvoices: 'Unpaid Invoices',
      deltaSibBalance: 'DeltaSib Balance',
      lastPayment: 'Last Payment',
      quickbooksSummary: 'QuickBooks Summary',
      deltaSibService: 'DeltaSib Service',
      deltaSibPayments: 'DeltaSib Payments',
      service: 'Service',
      description: 'Description',
      price: 'Price',
      type: 'Type',
      paymentStatus: 'Payment Status',
      paid: 'Paid',
      unpaid: 'Unpaid',
      summary: 'Summary',
      used: 'Used',
      remaining: 'Remaining'
    },
    actions: {
      resetDevice: 'Reset Device',
      temporaryActivation: 'Temporary Activation',
      changePackage: 'Change Package',
      addExtraVolume: 'Add Extra Volume',
      addExtraTime: 'Add Extra Time',
      printReceipt: 'Print Receipt',
      addToProblemList: 'Add to Problem List',
      configureRouter: 'Configure Router',
      increaseSpeed: 'Increase Speed',
      scheduleContact: 'Schedule Contact',
      customerVisit: 'Customer Visit',
      supportFeedback: 'Support Feedback',
      comingSoon: 'Coming Soon',
      notImplemented: 'This action is not yet implemented'
    },
    static: 'Static (waiting for data)',
    notAvailable: 'Not Available',
    currentService: 'Current Service',
    balanceSummary: 'Balance Summary',
    usageUsed: 'Used',
    usageExpired: 'Expired',
    days: 'days',
    unlimited: 'Unlimited',
    totalData: 'Total',
    daysRemaining: 'Days Remaining'
  },
  manage: {
    title: 'Manage Customer',
    steps: {
      customer: 'Customer',
      devices: 'Devices',
      assign: 'Assign',
      installation: 'Installation'
    },
    form: {
      save: 'Save Customer',
      submit: 'Submit',
      approve: 'Approve',
      reject: 'Reject',
      submitInstallation: 'Submit Installation Form'
    },
    accessDenied: 'Access Denied'
  },
  form: {
    title: 'Customer Form',
    contractId: 'Contract ID',
    refreshContractId: 'Refresh contract ID',
    nameFa: 'Name (FA)',
    lastNameFa: 'Last Name (FA)',
    displayName: 'Display Name',
    nameFaPlaceholder: 'نام به فارسی',
    lastNameFaPlaceholder: 'نام خانوادگی به فارسی',
    displayNamePlaceholder: 'Enter display name',
    class: 'Class',
    location: 'Location',
    selectClass: 'Select class (optional)',
    selectLocation: 'Select location (optional)',
    noClass: '— No class —',
    noLocation: '— No location —',
    selectStatus: 'Select status',
    customerType: 'Customer Type',
    individual: 'Individual',
    business: 'Business',
    username: 'Username',
    password: 'Password',
    date: 'Date',
    companyName: 'Company Name',
    activity: 'Activity',
    name: 'Name',
    lastName: 'Last Name',
    email: 'Email',
    licenseNo: 'License No',
    nid: 'NID (Optional)',
    address: 'Address',
    devices: 'Devices',
    visp: 'VISP',
    selectVisp: 'Select VISP',
    center: 'Center',
    selectCenter: 'Select Center',
    reseller: 'Reseller',
    branch: 'Branch',
    selectBranch: 'Select Branch',
    customerStatus: 'Customer Status',
    demo: 'Demo',
    final: 'Final',
    errors: {
      serviceRequired: 'Please select a service package before submitting'
    },
    phone: 'Phone',
    phonePlaceholder: 'Enter phone number',
    mobile: 'Mobile',
    mobilePlaceholder: 'Enter mobile number',
    note: 'Contract Note',
    notePlaceholder: 'Max 100 characters',
    phones: {
      title: 'Phone Numbers',
      add: 'Add Phone Number',
      placeholder: 'Enter phone number'
    },
    package: 'Package',
    discountCommentLabel: 'Discount Note',
    isPrinted: 'Contract printed',
    isSigned: 'Contract signed',
    selectPackage: 'Select a package',
    searchPackages: 'Search packages...',
    customFields: {
      title: 'Custom Fields',
      add: 'Add Custom Field',
      key: 'Enter key',
      value: 'Enter value'
    },
    submit: 'Save Customer',
    saveAndPrint: 'Save & Print',
    selectDate: 'Select date',
    selectCustomerType: 'Select customer type',
    usernamePlaceholder: "name{'@'}family",
    companyNamePlaceholder: 'Enter company name',
    activityPlaceholder: 'Enter business activity',
    namePlaceholder: 'Enter name',
    lastNamePlaceholder: 'Enter last name',
    emailPlaceholder: 'Enter email address',
    licenseNoPlaceholder: 'Enter license number',
    nidPlaceholder: 'Enter NID',
    addressPlaceholder: 'Enter address',
    internetUsage: {
      title: 'Have you had wireless internet before?',
      yes: 'Yes',
      ispName: 'From which ISP',
      ispNamePlaceholder: 'Enter ISP name'
    },
    internetPurpose: {
      title: 'Why you use Internet?',
      placeholder: 'Select internet usage purpose',
      homeUse: 'Home Use',
      onlineGaming: 'Online Gaming',
      business: 'Business',
      exchange: 'Exchange',
      travelAgency: 'Travel Agency'
    },
    findUs: {
      title: 'How did you find FR-ISP?',
      placeholder: 'Select how you found us',
      brochure: 'Brochure',
      marketer: 'Marketer',
      socialMedia: 'Social Media',
      billboard: 'Billboard',
      customerReferral: 'Customer Referral',
      farsroute: 'Farsroute',
      tvAds: 'TV Ads',
      sms: 'SMS',
      whatsapp: 'WhatsApp'
    },
    previousPackage: {
      title: 'Previous Package',
      placeholder: 'Select previous package',
      dedicated: 'Dedicated',
      dedicatedCombined: 'Dedicated Combined',
      dedicatedDaily: 'Dedicated Daily',
      volumeShortTerm: 'Volume Short Term',
      volumeLongTerm: 'Volume Long Term',
      volumeDailyLimited: 'Volume Daily Limited'
    },
    terminationReasons: {
      title: 'Termination Reasons',
      placeholder: 'Select termination reason',
      price: 'Price',
      quality: 'Quality',
      customerService: 'Customer Service',
      speed: 'Speed',
      relocation: 'Relocation',
      other: 'Other'
    },
    selectCustomer: 'Select customer',
    searchCustomer: 'Search customers...'
  },
  service: {
    table: {
      name: 'Service Name',
      serviceId: 'Service ID',
      price: 'Price',
      discount: 'Discount',
      discountTypeColumn: 'Discount type',
      discountScopeColumn: 'Discount Scope',
      discountValueColumn: 'Discount value',
      finalPrice: 'Final Price'
    },
    discountType: {
      amount: 'Discount value',
      percent: 'Discount %'
    },
    dropdown: {
      idLabel: 'ID'
    }
  },
  devices: {
    title: 'Devices',
    customerHasOwnDevice: 'Customer already has equipment (no devices to add)',
    provision: {
      sold: 'Purchased',
      leased: 'Leased'
    },
    add: 'Add Device',
    addAnotherLine: 'Pick a device below to add another line.',
    emptyLineHint: 'Click to add device',
    cancelNewLine: 'Cancel',
    selectDevice: 'Select a device',
    searchDevices: 'Search devices...',
    table: {
      name: 'Device',
      sku: 'SKU',
      description: 'Description',
      unit: 'Unit',
      unitPrice: 'Unit price',
      price: 'Price',
      quantity: 'Quantity',
      lineTotal: 'Line total',
      provision: 'Provision'
    },
    totalAmount: 'Total Amount',
    submit: 'Submit'
  },
  installation: {
    title: 'Installation',
    form: {
      date: 'Date',
      selectDate: 'Select date',
      type: 'Type',
      types: {
        installation: 'Installation',
        troubleshooting: 'Troubleshooting'
      },
      status: {
        title: 'Status',
        pending: 'Pending',
        inProgress: 'In Progress',
        done: 'Done',
        failed: 'Failed'
      },
      jobDetails: 'Job details',
      contractPackage: 'Contract package (sales)',
      installedPackage: 'Installed package',
      selectPackage: 'Select package',
      deviceSource: 'Device source',
      selectDeviceSource: 'Select device source',
      linkPerformance: 'Link performance',
      customerInfo: {
        name: 'Customer Name',
        phone: 'Phone',
        mobile: 'Mobile',
        address: 'Address'
      },
      details: {
        site: 'Site',
        sitePlaceholder: 'POP site / tower location',
        signalStrength: 'Signal strength',
        signalStrengthPlaceholder: 'e.g. -60',
        signalToNoise: 'Signal to noise (SNR)',
        signalToNoisePlaceholder: 'e.g. 30',
        signal: 'Signal',
        ccq: 'CCQ',
        ccqPlaceholder: 'e.g. 95',
        base: 'Base',
        cable: 'Cable',
        router: 'Router',
        antenna: 'Antenna',
        note: 'Note',
        cancelReason: 'Cancel Reason'
      },
      actions: {
        approve: 'Approve',
        reject: 'Reject',
        submit: 'Submit Installation'
      },
      drawer: {
        title: 'Installation details',
        description: 'Field report for this customer',
        deviceSource: 'Device source',
        approved: 'Approved',
        jobNumber: 'Job #',
        openForm: 'Open installation form',
        loading: 'Loading installation…',
        noInstallation: 'No installation data available',
        loadError: 'Could not load installation details.',
        close: 'Close',
        installerDetails: 'Installer',
        installerName: 'Name',
        installerEmail: 'Email',
        installerBranch: 'Branch',
        taskStatus: 'Task status',
        assignedAt: 'Assigned at',
        notAssigned: 'No installer assigned yet',
      }
    }
  },
  filter: {
    all: 'All',
    individual: 'Individual',
    business: 'Business'
  },
  actions: {
    add: 'Add Customer',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    menu: 'Open menu',
    title: 'Actions',
    copyId: 'Copy Customer ID',
  },
  drawer: {
    printContract: 'Print contract',
  },
  columns: {
    id: 'ID',
    name: 'Name',
    licenseOrNID: 'License / NID',
    email: 'Email',
    address: 'Address',
    phones: 'Phone Numbers',
    fields: 'Fields',
    devices: 'Devices',
    noPhone: 'No Phone',
    noFields: 'No Fields',
    noDevices: 'No devices',
    deviceCount: '{count} device(s)',
    installationStatus: 'Installation Status'
  },
  notifications: {
    customerUpdated: '{name}\'s information has been updated successfully!',
    customerAdded: '{name} has been successfully added as a customer!',
    deviceUpdated: 'Devices have been updated successfully!',
    installationUpdated: 'Installation has been updated successfully!',
    usernameExists: 'This username is already taken. Please choose a different username.',
    processFailed: 'Failed to process customer.',
    deviceUpdateFailed: 'Failed to update {name}\'s devices.',
    installationFailed: 'Failed to submit installation for {name}.',
    idCopied: 'Customer ID has been copied to clipboard',
    customerDeleted: '{name} has been successfully deleted',
    deleteFailed: 'Failed to delete customer. Please try again.',
    statusUpdated: '{name}\'s status has been updated successfully!',
    statusUpdateFailed: 'Failed to update customer status. Please try again.',
  },
  common: {
    success: 'Success',
    error: 'Error',
    loading: 'Loading...',
    submitting: 'Submitting...',
    customer: 'Customer',
    optional: 'Optional'
  },
  roles: {
    admin: 'Admin',
    noc: 'NOC',
    installer: 'Installer'
  },
  dialog: {
    errors: {
      title: 'Error',
      noPhone: 'Phone Number Required',
      phoneRequired: 'Please add at least one phone number before submitting'
    },
    success: {
      title: 'Success',
      customerAdded: 'Customer added successfully',
      customerUpdated: 'Customer updated successfully'
    }
  },
  syncDrawer: {
    title: 'Edit Customer & Sync',
    badge: 'Sync Engine V2',
    description: 'Live two-way sync with DeltaSIB & QuickBooks — Retrieve source: SIB/QBO | Edit source: CRM',
    checkInSibAndQbo: 'Check in SIB & QBO',
    printContract: 'Print Contract',
    syncStatusTitle: 'System Sync Status (DeltaSIB & QuickBooks)',
    clickCheckToVerify: 'Click "Check in SIB & QBO" to verify live synchronization',
    checkingSystems: 'Checking DeltaSIB and QuickBooks systems...',
    activeMismatches: '{count} active mismatch | {count} active mismatches',
    allSynced: 'All systems fully synchronized',
    autoSyncUponSave: 'Auto-sync outward upon save',
    statusSynced: 'Synced',
    statusActionNeeded: 'Action Needed',
    statusNeedsSync: 'Needs Sync',
    statusUnlinked: 'Unlinked',
    needsSync: 'Needs sync',
    synced: 'Synced',
    autoSyncOnSave: 'Auto-sync on save',
    applyCrmValues: 'Apply CRM values',
    correctInCrm: 'Fix in CRM',
    reMatch: 'Match',
    mismatchQuestion: 'has a mismatch. Which value is correct?',
    applyCrmToSystem: 'Apply CRM value in {system}',
    applySystemToCrm: 'Apply {system} value in CRM',
    applySibToQbo: 'Apply SIB value in QuickBooks',
    applyDeltaToBoth: 'Apply DeltaSIB value in CRM & QBO',
    unlinkedWarning: 'No record found for this customer. Sync is paused until matched.',
    noMismatches: 'All systems are synchronized',
    applyCrmToAllSystems: 'Apply CRM values to all linked systems',
    applyCrmToAllNotice: 'Fields owned by external systems (like username) will not be overwritten',
    pushCrmToSib: 'Push CRM to SIB',
    pushCrmToQbo: 'Push CRM to QBO',
    changeMatch: 'Change Match',
    findMatch: 'Find Match',
    hideDetails: 'Hide Details',
    systemDetails: 'System Details',
    deltaSibUnlinkedBanner: 'No matching DeltaSIB account linked.',
    qboUnlinkedBanner: 'Customer not connected in QuickBooks. Invoicing paused.',
    sourceDeltaSib: 'Source: DeltaSIB',
    sibValueChanged: 'Value of {field} changed in SIB:',
    updateInCrm: 'Update {field} in CRM & QBO',
    mismatchBetween: 'Mismatch in {field} ({system})',
    mismatchPrompt: 'Values differ between systems. Choose which value to apply:',
    currentCrmValue: 'Current in CRM',
    remoteLiveValue: 'Live in {system}',
    overwriteRemote: '➔ Overwrite {system}',
    applyToCrm: '➔ Apply to CRM',
    allDataSynced: 'All customer data is fully synchronized across DeltaSIB and QuickBooks',
    applyAll: 'Apply All Live Updates to CRM',
    applyAllSubtitle: 'Updates CRM customer fields with live data from DeltaSIB & QuickBooks',
    applyAllNotice: 'SIB-owned fields (like username) are pulled into CRM & QBO without overwrite',
    pendingEdits: '{count} pending edits in CRM form:',
    saveAndPush: 'Save & Push to SIB / QBO',
    contractPrinted: 'Contract Printed',
    contractSigned: 'Contract Signed',
    printed: 'Printed',
    signed: 'Signed',
    crmInfoTitle: 'CRM Customer Information',
    crmInfoSubtitle: 'Primary edit source: CRM — changes will be pushed outward to SIB and QBO',
    customerType: 'Customer Type',
    individual: 'Individual',
    business: 'Business',
    registrationDate: 'Registration Date',
    customerStatus: 'Customer Status',
    selectStatus: 'Select Status',
    billingCategory: 'Billing Category',
    selectCategory: 'Select Category',
    contractId: 'Contract ID',
    username: 'Username',
    usernameLockedTooltip: 'This field is owned by DeltaSIB and locked in CRM',
    nameFa: 'First Name (Farsi/Dari)',
    lastNameFa: 'Last Name / Family (Farsi/Dari)',
    nameEn: 'First Name (English)',
    lastNameEn: 'Last Name (English)',
    displayName: 'Display Name (QBO & Systems)',
    mobile: 'Mobile Number',
    phone: 'Primary Phone',
    email: 'Email',
    paymentTerms: 'Payment Terms',
    address: 'Full Address',
    companyName: 'Company Name',
    licenseNo: 'License No',
    allSystemsSynced: 'All systems synchronized',
    itemsPendingSync: '{count} items pending sync',
    cancel: 'Cancel',
    saveAndSync: 'Save & Sync',
    saving: 'Saving…',
    matchModalTitle: 'Match Customer with {system}',
    matchModalDescription: 'Search by name, ID, or phone in {system}',
    searchPlaceholder: 'Search by name, ID, phone, username...',
    noMatchFound: 'No matching candidates found',
    link: 'Link',
    close: 'Close',
    confirmModalTitle: 'Confirm Save & Outward Sync',
    confirmModalDescription: 'The following changes will be saved to CRM and synchronized outward:',
    modifiedFields: 'Modified Fields:',
    noManualEdits: 'No manual field edits — full system reconciliation will be performed.',
    targetSystems: 'Target Systems for Outward Sync:',
    backToEditing: 'Back to Editing',
    confirmAndSave: 'Confirm & Save',
    fields: {
      name: 'First Name (EN)',
      lastName: 'Last Name (EN)',
      nameFa: 'First Name (FA)',
      lastNameFa: 'Last Name (FA)',
      displayName: 'Display Name',
      email: 'Email',
      phone: 'Primary Phone',
      mobile: 'Mobile Phone',
      address: 'Address',
      contractId: 'Contract ID',
      username: 'Username',
      companyName: 'Company Name',
      licenseNo: 'License No'
    }
  }
} 